module.exports = __webpack_public_path__ + "static/media/cases_item_3.b68f16f7.png";